/*
 * @Description:
 * @Author: yuqing.hao
 * @Date: 2019-12-18 20:47:39
 * @LastEditTime: 2020-11-18 14:52:40
 * @LastEditors: yuqing.hao
 */
import PropTypes from 'prop-types';
import React from 'react';
import {Dialog} from '@alifd/next';

export default function DialogModal(props) {
	const {
		visible,
		className = '',
		dialogContent = {},
		contentEl,
	} = props;
	const {
		onOk,
		content,
		onClose,
		onCancel,
		title = '',
		footer = true,
		hasMask = true,
		footerAlign = 'right', // 'left', 'center', 'right'
		footerActions = ['ok', 'cancel'], // ['ok', 'cancel'], ['cancel', 'ok'], ['ok'], ['cancel']
		okProps = {
			// className = ""
			// loading = false,
			// children = "确定",
		},
		cancelProps = {
			// className = ""
			// loading = false,
			// children = "取消",
		},
	} = dialogContent;
    
	return (
		<Dialog
			onOk={onOk}
			footer={footer}
			visible={visible}
			hasMask={hasMask}
			onClose={onClose}
			okProps={okProps}
			title={title || ''}
			shouldUpdatePosition
			className={className}
			footerAlign={footerAlign}
			cancelProps={cancelProps}
			footerActions={footerActions}
			onCancel={onCancel || onClose}
		>
			<div style={{minWidth: '300px'}}>
				{content || ''}
				{contentEl || ''}
			</div>
		</Dialog>
	);
}

DialogModal.propTypes = {
	visible: PropTypes.bool,
	className: PropTypes.string,
	dialogContent: PropTypes.object,
	contentEl: PropTypes.any,
};

DialogModal.defaultProps = {
	className: '',
	contentEl: '',
	visible: false,
	dialogContent: {},
};
